var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKonsultan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 66,
    viewBox: "0 0 76 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9171 51.0103L60.3457 45.4357C65.4886 40.29 68.4886 33.429 68.4886 26.1392C68.4886 18.8494 65.4886 11.9884 60.3457 6.84268L65.9171 1.26813C79.6314 15.4189 79.6314 37.7171 65.9171 51.0103Z",
    fill: "#8B98A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2029 40.29L49.6314 34.7154C54.3457 29.9985 54.3457 22.7087 49.6314 17.9918L55.2029 12.4172C62.4886 20.1358 62.4886 32.5714 55.2029 40.29Z",
    fill: "#8B98A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2029 65.5899H41.4886C41.4886 57.0136 34.6314 50.1527 26.06 50.1527C17.4886 50.1527 10.6314 57.0136 10.6314 65.5899H2.48859C2.48859 52.7255 12.7743 42.0052 26.06 42.0052C39.3457 42.0052 49.2029 52.2967 49.2029 65.5899Z",
    fill: "#8B98A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6315 6.84265C17.06 6.84265 10.2029 13.7036 10.2029 22.2799C10.2029 30.8561 17.06 37.7171 25.6315 37.7171C29.9172 37.7171 33.7743 36.0018 36.7743 33.0002C39.7743 30.4273 41.4886 26.568 41.4886 22.7087C41.4886 13.7036 34.2029 6.84265 25.6315 6.84265ZM33.3457 22.7087C33.3457 26.9968 29.4886 30.4273 25.2029 29.9985C20.9172 29.9985 17.4886 26.568 17.4886 22.2799C17.4886 17.9917 20.9172 14.5613 25.2029 14.5613C29.9172 14.5613 33.3457 18.4206 33.3457 22.7087Z",
    fill: "#8B98A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2449 49.7239L58.1021 44.5782C63.2449 39.4324 65.8163 33.0003 65.8163 25.7105C65.8163 18.4207 62.8163 11.9885 58.1021 6.84276L63.2449 1.69702C76.9592 14.9902 76.9592 36.4307 63.2449 49.7239Z",
    fill: "#0089EF",
    stroke: "#3A2C60",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5307 39.0036L46.9592 33.4291C51.2449 29.141 51.2449 21.8512 46.9592 17.1342L52.5307 11.5597C60.2449 19.7071 60.2449 31.7138 52.5307 39.0036Z",
    fill: "#0089EF",
    stroke: "#3A2C60",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9592 63.8747H39.2449C39.2449 55.2985 32.3878 48.8663 24.2449 48.8663C16.1021 48.8663 9.24493 55.7273 9.24493 63.8747H1.53064C1.53064 51.4392 11.8164 41.1477 24.2449 41.1477C36.6735 41.1477 46.9592 51.0104 46.9592 63.8747Z",
    fill: "#0089EF",
    stroke: "#3A2C60",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2449 6.84277C15.6735 6.84277 9.24493 13.7038 9.24493 21.8512C9.24493 29.9986 16.1021 36.8596 24.2449 36.8596C28.1021 36.8596 31.9592 35.1443 34.9592 32.5715C37.9592 29.5698 39.2449 25.7105 39.2449 21.8512C39.2449 13.7038 32.3878 6.84277 24.2449 6.84277ZM31.5306 22.28C31.5306 26.5681 28.1021 29.5698 23.8164 29.5698C19.9592 29.5698 16.5306 26.1393 16.5306 21.8512C16.5306 17.5631 19.9592 14.5614 24.2449 14.5614C28.1021 14.5614 31.5306 17.9919 31.5306 22.28Z",
    fill: "#0089EF",
    stroke: "#3A2C60",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 65.9184,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonsultan);
export default __webpack_public_path__ + "static/media/konsultan.83c67d66c0768d7543f9f8f15c8bef65.svg";
export { ForwardRef as ReactComponent };